import { ComponentFactoryResolver, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@shared/shared.module';
import { MatDialogRef } from '@angular/material/dialog';
import { DragDropModule } from '@angular/cdk/drag-drop';
import {
  EliteFormDynamicComponentHelper
} from '@features/elite-form/elite-form-dynamic-component-helper';
import { PlatformToolEliteFormHandler } from '@features/elite-form/platform-tool-handlers/platform-tool-elite-form-handler';
import { PlatformToolEliteFormDesignComponent } from './components/platform-tool-elite-form-design/platform-tool-elite-form-design.component';
import { SelectFieldNotebookCardComponent } from './components/cards/select-field-notebook-card/select-field-notebook-card.component';
import { EliteFormDesignerLeftSidebarComponent } from './components/elite-form-designer-left-sidebar/elite-form-designer-left-sidebar.component';
import { EliteFormCanvasDesignContainerComponent } from '@features/elite-form/components/elite-form-canvas-design-container/elite-form-canvas-design-container.component';
import { EliteFormResponseContainerComponent } from './components/response-components/elite-form-response-container/elite-form-response-container.component';
import { EliteFormSinglePageResponseComponent } from './components/response-components/elite-form-single-page-response/elite-form-single-page-response.component';
import { PlatformToolEliteFormResponseComponent } from './components/response-components/platform-tool-elite-form-respnose/platform-tool-elite-form-response.component';
import { EliteFormManagerService } from "@features/elite-form/services/elite-form-manager.service";
import { EliteFormPagesContainerComponent } from './components/elite-form-pages-container/elite-form-pages-container.component';
import { EliteFormResponsePageSingleSectionComponent } from './components/response-components/elite-form-response-page-single-section/elite-form-response-page-single-section.component';
import { DialogFieldInputRequirementsEditorComponent } from './components/dialog-fields/dialog-field-input-requirements-editor/dialog-field-input-requirements-editor.component';
import { RootDynamicComponentHelper } from "@shared/helpers/root-dynamic-component-helper";
import { DialogFieldOptionsManagerEditorComponent } from './components/dialog-fields/dialog-field-options-manager-editor/dialog-field-options-manager-editor.component';
import { DialogFieldHtmlRendererComponent } from './components/dialog-fields/dialog-field-html-renderer/dialog-field-html-renderer.component';
import { DialogFieldStatusOptionsEditorComponent } from './components/dialog-fields/dialog-field-status-options-editor/dialog-field-status-options-editor.component';
import { DialogFieldCountrySelectorEditorComponent } from './components/dialog-fields/dialog-field-country-selector-editor/dialog-field-country-selector-editor.component';
import { DialogFieldEntitySelectorEditorComponent } from './components/dialog-fields/dialog-field-entity-selector-editor/dialog-field-entity-selector-editor.component';
import { AddRemoveFormsCommandHandler } from '@features/elite-form/platform-tool-handlers/add-remove-forms-command-handler';
import { DialogDefinitionQuestionnaireEditorComponent } from './components/dialog-fields/dialog-definition-questionnaire-editor/dialog-definition-questionnaire-editor.component';
import { EliteFormFieldDesignerCanvasComponent } from "@features/elite-form/components/elite-form-field-designer-canvas/elite-form-field-designer-canvas.component";
import { DialogFiledEliteFormGroupEditorComponent } from './components/dialog-fields/dialog-filed-elite-form-group-editor/dialog-filed-elite-form-group-editor.component';
import { DialogFiledEliteFormGroupTransposedEditorComponent } from './components/dialog-fields/dialog-filed-elite-form-group-transposed-editor/dialog-filed-elite-form-group-transposed-editor.component';
import { EliteFormGroupContainerComponent } from './components/response-components/elite-form-group-container/elite-form-group-container.component';
import { EliteFormGroupEditorContainerComponent } from './components/response-components/elite-form-group-editor-container/elite-form-group-editor-container.component';
import {FormResponseViewService} from "@features/elite-form/services/form-response-view.service";
import { EliteFormTableOfContentsContainerComponent } from './components/elite-form-table-of-contents/elite-form-table-of-contents-container/elite-form-table-of-contents-container.component';
import { EliteFormTableOfContentsItemComponent } from './components/elite-form-table-of-contents/elite-form-table-of-contents-item/elite-form-table-of-contents-item.component';
import { EliteFormValidationErrorComponent } from './components/elite-form-validation-error/elite-form-validation-error.component';
import { EliteFormValidationNotesDialogContentComponent } from './components/elite-form-validation-error/elite-form-validation-notes-dialog-content.component';
import { UserGuideValidationErrorsComponent } from './components/user-guide-validation-errors/user-guide-validation-errors.component';
import { FormMetadataImportPreviewComponent } from './components/form-metadata-import-preview/form-metadata-import-preview.component';
import { FormConfigFieldValuesInspectorComponent } from './components/form-config-fieldvalues-inspector/form-config-fieldvalues-inspector.component';



@NgModule({
  declarations: [
    EliteFormFieldDesignerCanvasComponent,
    PlatformToolEliteFormDesignComponent,
    SelectFieldNotebookCardComponent,
    EliteFormDesignerLeftSidebarComponent,
    EliteFormCanvasDesignContainerComponent,
    EliteFormResponseContainerComponent,
    EliteFormSinglePageResponseComponent,
    PlatformToolEliteFormResponseComponent,
    EliteFormPagesContainerComponent,
    EliteFormResponsePageSingleSectionComponent,
    DialogFieldInputRequirementsEditorComponent,
    DialogFieldOptionsManagerEditorComponent,
    DialogFieldHtmlRendererComponent,
    DialogFieldStatusOptionsEditorComponent,
    DialogFieldCountrySelectorEditorComponent,
    DialogFieldEntitySelectorEditorComponent,
    //PlatformToolEliteFormSetEditorComponentComponent,
    DialogFiledEliteFormGroupEditorComponent,
    DialogFiledEliteFormGroupTransposedEditorComponent,
    DialogDefinitionQuestionnaireEditorComponent,
    EliteFormGroupContainerComponent,
    EliteFormGroupEditorContainerComponent,
    EliteFormTableOfContentsContainerComponent,
    EliteFormTableOfContentsItemComponent,
    EliteFormValidationErrorComponent,
    UserGuideValidationErrorsComponent,
    FormMetadataImportPreviewComponent,
    FormConfigFieldValuesInspectorComponent,
    EliteFormValidationNotesDialogContentComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    DragDropModule,
  ],
  providers: [EliteFormManagerService, FormResponseViewService, { provide: MatDialogRef, useValue: {} }]
})
export class EliteFormModule {
  constructor(
    private componentFactoryResolver: ComponentFactoryResolver,
    private platformToolEliteFormHandler: PlatformToolEliteFormHandler,
    private addRemoveFormsCommandHandler: AddRemoveFormsCommandHandler
  ) {
    RootDynamicComponentHelper.registerComponentFactoryResolver(this.componentFactoryResolver);
    EliteFormDynamicComponentHelper.init();
    EliteFormDynamicComponentHelper.register('PlatformToolEliteFormHandler', platformToolEliteFormHandler);
    EliteFormDynamicComponentHelper.register('AddRemoveFormsCommandHandler', addRemoveFormsCommandHandler);
  }
}
